export default "__VITE_ASSET__28a9d308__"